import request from '@utils/request'

export const state = {
  cachedMessageId: '',
  cachedMemberId: '',
}

export const getters = {}

export const mutations = {
  CACHE_MESSAGE_ID(state, currentOrderMessage) {
    state.cachedMessageId = currentOrderMessage.data.id
  },
  CLEAR_MESSAGE_ID(state) {
    state.cachedMessageId = ''
  },
  CACHE_MEMBER_ID(state, id) {
    state.cachedMemberId = id
  },
}

export const actions = {
  findByPhone({ commit }, phoneData) {
    return request
      .post('/admin/merchant/member/searchByPhone', phoneData, {
        errorHandle: false,
      })
      .then((response) => response.items)
  },
  fetchSingle({ commit }, { memberId, page = 1 }) {
    return request.get(`/admin/merchant/member/${memberId}?page=${page}`).then((response) => response)
  },
  fetchSingleShort({ commit }, { memberId }) {
    return request.get(`/v2/admin/merchant/member/${memberId}`)
  },
  fetchMemberSummary({ commit }, { memberId }) {
    return request.get(`/v2/admin/merchant/member/${memberId}/summary`)
  },
  fetchMemberProfile({ commit }, { memberId }) {
    return request.get(`/v2/admin/merchant/member/${memberId}/profile`)
  },
  fetchMemberAvailablePrepaidOrders({ commit }, { memberId }) {
    return request.get(`/v2/admin/merchant/member/${memberId}/available-prepaid-orders`)
  },
  store({ commit }, storeData) {
    storeData.merchantNote = storeData.merchantNote ? storeData.merchantNote.replace(/<br\s\/>/g, '') : storeData.merchantNote
    return request.post('/admin/merchant/member/store', storeData)
  },
  fetchList({ commit }, query) {
    return request.all([request.post('/admin/merchant/member/search', query)]).then(
      request.spread((per, all) => {
        return {
          items: per.items,
          total: per.pagination?.total || 0,
        }
      })
    )
  },
  fetchListShort({ commit }, { search, cancelToken }) {
    return request
      .get(`/v2/admin/merchant/member/search/${encodeURIComponent(search)}`, {
        cancelToken,
        params: { limit: 30 },
      })
      .then((response) => ({
        items: response.items || [],
      }))
  },
  fetchListByKeyword({ commit }, query) {
    return request.post(`/admin/merchant/member/search`, query).then((response) => response)
  },
  /**
   * @description 獲取標籤選單
   */
  fetchTags({ commit }, search) {
    if (search === undefined) {
      search = {}
    }
    if (typeof search === 'object') {
      search['paginate'] = 0
    }
    return request.post('/admin/merchant/member/tag/search', search).then((response) => response)
  },
  storeTag({ commit }, storeData) {
    return request.post('/admin/merchant/member/tag/store', storeData)
  },
  removeTags({ commit }, removeData) {
    return request.post('/admin/merchant/member/tag/remove', removeData)
  },
  applyTags({ commit }, applyData) {
    return request.post('/admin/merchant/member/tag/apply', applyData)
  },

  fetchChats({ commit }, query) {
    return request.post('/admin/merchant/notifications/chat/getAllChatNotification', query).then((response) => {
      return {
        items: response.items,
        total: response.pagination?.total || 0,
      }
    })
  },
  fetchSingleChat({ commit }, search) {
    return request.post('/admin/merchant/extrarequest/getRecord', search).then((response) => response.items)
  },
  fetchMoreChat({ commit }, search) {
    return request.post('/admin/merchant/extrarequest/loadMoreChatRecord', search).then((response) => response.items)
  },
  fetchSpecificChat({ commit }, search) {
    return request.post('/admin/merchant/extrarequest/getSpecificRecord', search).then((response) => response.items)
  },
  storeChatReaded({ commit }, storeData) {
    return request.post('/admin/merchant/notifications/chat/readAllChatNotification', storeData)
  },
  sendChat({ commit }, submitData) {
    return request.post('/admin/merchant/member/extrarequest/request', submitData).then((response) => response)
  },
  replyChat({ commit }, submitData) {
    return request.post('/admin/merchant/member/extrarequest/reply', submitData).then((response) => response)
  },
  updateMessageId({ commit }, message) {
    commit('CACHE_MESSAGE_ID', message)
    setTimeout(() => {
      commit('CLEAR_MESSAGE_ID')
    }, 100)
  },
  fetchOrderRelatedChat({ commit }, search) {
    return request.post('/admin/merchant/extrarequest/getSpecificOrderRecord', search).then((response) => response)
  },
  updateActiveChatMemberId({ commit }, memberId) {
    commit('CACHE_MEMBER_ID', memberId)
  },
  /**
   * @description 使用人列表搜尋
   * @returns
   */
  fetchPetList({ commit }, search) {
    const { paginate } = search
    if (!paginate) {
      search['paginate'] = 0
    }
    return request.post('/admin/merchant/member/pet/search', search).then((response) => response)
  },
  removehPet({ commit }, removeData) {
    return request.post('/admin/merchant/member/pet/remove', removeData).then((response) => response)
  },
  fetchSinglePet({ commit }, { memberId, petId }) {
    return request.get(`/admin/merchant/member/${memberId}/pet/${petId}`).then((response) => response)
  },
  storeSinglePet({ commit }, submitData) {
    return request.post('admin/merchant/member/pet/store', submitData).then((response) => response)
  },
  // 黑名單
  async memberBlock({ commit }, { memberId, submitData }) {
    await request.post(`/admin/merchant/member/${memberId}/block`, submitData)
  },
  changePhone({ commit }, submitData) {
    return request.post(
      `/admin/merchant/member/changePhone`,
      {
        ...submitData,
      },
      {
        errorHandle: false,
        hideErrorMessage: true,
      }
    )
  },
}
